import React, { useState, useCallback } from 'react';
import { getIn } from 'formik';
import { CreateReport, OutrageForm } from '../../../components';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const SafetyForms: React.FC = () => {
  const [factAlreadySet, setFactAlreadySet] = useState(false);
  const [mask, setMask] = useState(false);
  const [barrierGestures, setBarrierGestures] = useState(false);

  const handleOnchange = useCallback(
    (form) => {
      if (!form) return;
      const outrageFact = !!getIn(form.values, 'fieldReportsDto.outrage.statements');
      const enableMask = !!getIn(form.values, 'fieldReportsDto.sanitaryOffense.noMask.noRespect');
      const enableBarrierGestures = !!getIn(
        form.values,
        'fieldReportsDto.sanitaryOffense.noRespectBarrierGestures.noRespect'
      );
      const { setFieldValue } = form;

      if (outrageFact !== factAlreadySet) {
        setFactAlreadySet(outrageFact);
      }

      if (enableMask !== mask) {
        if (!enableMask) {
          setFieldValue('fieldReportsDto.sanitaryOffense.noMask.nbrPerson', 0);
        }
        setMask(enableMask);
      }

      if (enableBarrierGestures !== barrierGestures) {
        if (!enableBarrierGestures) {
          setFieldValue('fieldReportsDto.sanitaryOffense.noRespectBarrierGestures.nbrPerson', 0);
        }
        setBarrierGestures(enableBarrierGestures);
      }
    },
    [factAlreadySet, mask, barrierGestures]
  );

  return (
    <CreateReport
      initialValues={{
        fieldReportsDto: {
          agentType: '',
          outrage: {
            pvDate: new Date(),
          },
        },
      }}
      themeShortCode={paths.safety.themeShortCode || ''}
      otherFields={{
        'fieldReportsDto.timeOfIncident': {
          type: 'time',
          label: "Heure d'incident",
          grid: 6,
        },

        'fieldReportsDto.agentType': {
          type: 'radio',
          label: 'Je suis ',
          initialValue: 'bord',
          grid: 12,
          options: [
            {
              value: 'Chef de Train',
              label: 'Chef de Train',
            },
            {
              value: 'Responsable Commercial et Service',
              label: 'Responsable Commercial et Service',
            },
          ],
        },
        section1: {
          type: 'section',
          label: 'SITUATION A BORD',
          grid: 12,
        },
        'fieldReportsDto.situationOnBoard.presenceSUGE': {
          type: 'switch',
          label: 'Présence de la SUGE / Agent de sûreté',
          grid: 6,
        },
        'fieldReportsDto.situationOnBoard.riRequest': {
          type: 'switch',
          label: 'Demande de RI',
          grid: 6,
        },
        'fieldReportsDto.situationOnBoard.riSucces': {
          type: 'switch',
          label: 'RI abouti',
          grid: 6,
        },
        'fieldReportsDto.situationOnBoard.iatRequest': {
          type: 'switch',
          label: 'Demande IAT',
          grid: 6,
        },
        'fieldReportsDto.nbrPV': {
          type: 'number',
          label: 'Nombre de pv',
          grid: 6,
        },
        'fieldReportsDto.nbrReceipts': {
          type: 'number',
          label: "Nombre d'encaissement",
          grid: 6,
        },
        section2: {
          type: 'section',
          name: 'section',
          label: "NIVEAU D'INFRACTION",
          grid: 12,
        },
        'fieldReportsDto.controlDifficulty': {
          type: 'switch',
          label: 'Difficultés de contrôle',
          grid: 6,
        },
        'fieldReportsDto.defectiveTicket': {
          type: 'switch',
          label: 'Défaut de titre de transport',
          grid: 6,
        },
        section3: {
          type: 'section',
          label: 'NIVEAU DE PRIORITÉ 1',
          grid: 12,
        },
        'fieldReportsDto.priorityLevelOne.incivilityBetweenClients': {
          type: 'switch',
          label: 'Incivilité entre clients',
          grid: 6,
        },
        'fieldReportsDto.priorityLevelOne.maliciousAct': {
          type: 'switch',
          label: 'Acte de malveillance',
          grid: 6,
        },
        'fieldReportsDto.priorityLevelOne.steal': {
          type: 'switch',
          label: 'Vol',
          grid: 6,
        },
        section4: {
          type: 'section',
          label: 'NIVEAU DE PRIORITÉ 2',
          grid: 12,
        },
        'fieldReportsDto.priorityLevelTwo.abandonedPackage': {
          type: 'switch',
          label: 'Objet délaissé',
          grid: 12,
        },
        'fieldReportsDto.priorityLevelTwo.aggression': {
          type: 'switch',
          label: 'Atteinte',
          grid: 6,
        },
        'fieldReportsDto.priorityLevelTwo.attemptedAssault': {
          type: 'switch',
          label: "Tentative d'atteinte",
          grid: 6,
        },

        'fieldReportsDto.priorityLevelTwo.threat': {
          type: 'switch',
          label: 'Menace',
          grid: 6,
        },
        'fieldReportsDto.priorityLevelTwo.insult': {
          type: 'switch',
          label: 'Insultes',
          grid: 6,
        },
        outrage: {
          type: 'custom',
          label: 'outrage',
          component: <OutrageForm />,
        },
        section5: {
          type: 'section',
          label: 'SITUATION ACCUEIL À QUAI',
          grid: 12,
        },
        'fieldReportsDto.boardingSituation.adsAbsence': {
          type: 'switch',
          label: 'Absence ADS',
          grid: 6,
        },
        'fieldReportsDto.boardingSituation.difficultRegularization': {
          type: 'switch',
          label: 'Régularisation difficile',
          grid: 6,
        },
        'fieldReportsDto.boardingSituation.disturbedSituation': {
          type: 'switch',
          label: 'Situation pertubée',
          grid: 6,
        },
        'fieldReportsDto.boardingSituation.travelerRefusal': {
          type: 'switch',
          label: 'Refus de voyageurs H-5 ou H-3',
          grid: 6,
        },
        section6: {
          type: 'section',
          label: 'INFRACTION SANITAIRE',
          grid: 12,
        },
        'fieldReportsDto.sanitaryOffense.noMask.noRespect': {
          type: 'switch',
          label: 'Non port de masque',
          grid: 6,
        },
        'fieldReportsDto.sanitaryOffense.noMask.nbrPerson': {
          type: 'input-range',
          label: "Nombre d'individus",
          disabled: !mask,
          grid: 6,
        },
        'fieldReportsDto.sanitaryOffense.noRespectBarrierGestures.noRespect': {
          type: 'switch',
          label: 'Non-respect des gestes barrière',
          grid: 6,
        },
        'fieldReportsDto.sanitaryOffense.noRespectBarrierGestures.nbrPerson': {
          type: 'input-range',
          label: "Nombre d'individus",
          disabled: !barrierGestures,
          grid: 6,
        },
        'fieldReportsDto.sanitaryOffense.socialDistancing': {
          type: 'switch',
          name: 'affluence',
          label: 'Affluence distanciation sociale',
          grid: 6,
        },

        'fieldReportsDto.comment': {
          type: 'text',
          name: 'fact',
          placeholder: factAlreadySet
            ? 'Les faits ont été exposés dans le PV pour outrage, il n’est pas nécessaire de les ressaisir dans ce champ.'
            : '',
          label: 'Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      onChange={handleOnchange}
      validationSchema={Yup.object({
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
        fieldReportsDto: Yup.object().shape({
          outrage: Yup.object({}).when('priorityLevelTwo.outrage', (outrage: any) => {
            if (outrage) {
              return Yup.object().shape({
                placeIcident: Yup.string().required('Ce champ est requis').nullable(),
                statements: Yup.string().required('Ce champ est requis').nullable(),
              });
            }
          }),
        }),
      })}
    />
  );
};

export default SafetyForms;
